// extracted by mini-css-extract-plugin
module.exports = {"video":"rW"};